/**
 * Cognito group for Game Names Management.
 * Keep in sync with services/ms-casino userFlagHelper
 * GAME_NAMES_MANAGEMENT_GROUP / canAccessGameNamesManagement.
 */
export const GAME_NAMES_MANAGEMENT_GROUP = 'slotcheck-enterprise-gameNamesManagement';

/** True when cognito:groups includes the Game Names Management enterprise group. */
export function canAccessGameNamesManagement(groups: string[] = []): boolean {
  return Array.isArray(groups) && groups.includes(GAME_NAMES_MANAGEMENT_GROUP);
}

/** Side menu item is shown only to game-names-management group members. */
export function shouldShowGameNamesManagementMenu(groups: string[] = []): boolean {
  return canAccessGameNamesManagement(groups);
}
